import { Component, computed, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CurrencyPipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

import { LivefeedService } from '../services/livefeed.service';
import { ResponsiveService } from '../services/responsive.service';
import { AmazonImagePipe } from '../shared/amazon-image.pipe';
import { CURRENCY_MAP } from '../../../shared/constants';
import { DomainKey } from '../../../shared/types/product';
import { LivefeedEvent } from '../../../shared/types/livefeed-event';

@Component({
  selector: 'app-livefeed-mini',
  templateUrl: './livefeed-mini.component.html',
  styleUrls: ['./livefeed-mini.component.scss'],
  standalone: true,
  imports: [CurrencyPipe, MatIconModule, RouterLink, AmazonImagePipe],
})
export class LivefeedMiniComponent {
  readonly domain = input<DomainKey>('1');
  currencyMap = CURRENCY_MAP;
  private readonly responsive = inject(ResponsiveService);

  readonly visible = computed(() =>
    !this.responsive.isSmallScreen() && this.livefeedService.events().length > 0
  );

  readonly recentEvents = computed(() =>
    this.livefeedService.events().slice(0, 5)
  );

  constructor(readonly livefeedService: LivefeedService) {}

  trackByEventId(_index: number, event: LivefeedEvent): number {
    return event.id;
  }
}
